/**
 * Created by tomers on 3/3/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Media = require("media");
    var template = require("personalization-web-agent-templates/awayReasonsEdit.tmpl");
    var Button = require("ui/button/Button");
    var AwayReasonItemView = require("personalization-web-agent-views/away-reasons/AwayReasonItemView");
    var positionsUtility = require("personalization-utils/positionsUtility");

    var AwayReasonsEditView = {};

    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        AwayReasonsEditView = Marionette.CompositeView.extend({
            template: template,
            className: "away-reasons-edit-view anchor",
            itemView: AwayReasonItemView,
            itemViewContainer: ".away-reasons-list-container",
            ui: {
                newAwayReasonLinkContainer: ".away-reasons-new-link",
                newButton: ".new-button",
                doneButton: ".done-button",
                dialogContainer: ".away-reason-edit-dialog-container"
            },
            uiComponents: {
                newButton: {
                    type: Button,
                    options: {
                        el: "view.ui.newButton",
                        permutation: Button.PERMUTATION.LIGHT_BLUELINK
                    },
                    events: {
                        "click": "_onNewClick"
                    }
                },
                doneButton: {
                    type: Button,
                    options: {
                        el: "view.ui.doneButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onDoneClick"
                    }
                }
            },

            initialize: function (options) {
                this.anchorSelector = options.anchorSelector;
                this.channel = Media.channel(LE.mediaCodes.personalization.channels.AWAY_REASONS);
                this.collection = options.collection;
            },

            onRender: function () {
                var offset = positionsUtility.getOffset(this.anchorSelector, positionsUtility.POSITION_X.RIGHT, positionsUtility.POSITION_Y.TOP);
                if (offset) {
                    this.$el.css(offset);
                }
                this._toggleAddNewLink();

                this.listenTo(this.collection, "add remove", this._toggleAddNewLink);
                this.listenTo(this.channel, "awayReasons:showDialog", this._showDialog);
                this.listenTo(this.channel, "awayReasons:closeDialog", this._closeDialog);
            },

            _toggleAddNewLink: function() {
                var isEnabled = this.collection.size() < this.collection.getMaxSize();
                var tooltip = (isEnabled) ? "" : LE.translator.translate("LEPersonalization.webAgent.agentState.edit.awayReasons.maxEntities.tooltip");
                this.uiComponents.newButton.setEnabled(isEnabled);
                this.uiComponents.newButton.setTooltip(tooltip);
            },

            _showDialog: function(dialogView) {
                this._closeDialog();
                this.dialogView = dialogView;
                this.ui.dialogContainer.append(this.dialogView.render().$el);
            },

            _closeDialog: function() {
                if (this.dialogView) {
                    this.dialogView.close();
                    this.dialogView = null;
                }
            },

            _onNewClick: function() {
                this.channel.trigger("awayReasons:list:new");
            },

            _onDoneClick: function () {
                this.channel.trigger("awayReasons:list:done");
            },

            onClose: function() {
                this._closeDialog();
            }
        });
    });

    return AwayReasonsEditView;

});
